export default __webpack_public_path__ + "6797689b842081986b8a1d4639859fda.png";